export const formStatusNameMap = (status: string) => {
  if (status === 'validation') {
    return 'EM VALIDAÇÃO';
  }

  if (status === 'done') {
    return 'CONCLUÍDO';
  }

  return 'PENDENTE';
};

export const formStatusTypeMap = (status: string) => {
  if (status === 'validation') {
    return 'info';
  }

  if (status === 'done') {
    return 'success';
  }

  return 'warning';
};
